import React from "react";
import { Link } from "react-router-dom";

const Partner = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="/img/part-dubai.avif"
          alt="Dubai Skyline"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-brand-deepBrown/85" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <span
          data-aos="fade-up"
          className="inline-block px-4 py-1.5 rounded-full bg-brand-orange text-white text-xs font-bold uppercase tracking-widest mb-6"
        >
          Global Expansion
        </span>

        <h2
          data-aos="fade-up"
          data-aos-delay="100"
          className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold mb-6"
        >
          Your Partner in <span className="text-brand-orange italic font-normal">Dubai</span>
        </h2>

        <p
          data-aos="fade-up"
          data-aos-delay="200"
          className="text-lg md:text-xl text-gray-200 font-light leading-relaxed mb-10 max-w-2xl mx-auto"
        >
          Guiding international businesses into Dubai with insights, strategy, and unmatched expertise.
        </p>

        <div data-aos="zoom-in" data-aos-delay="300">
          <Link to="/contact" className="btn-primary px-10 py-4">
            Explore Opportunities
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Partner;